// Typed, validated wrapper around Vite's import.meta.env.
//
// Fail loud at startup if a required public config var is missing — much
// easier to debug than a downstream Cognito SDK error.

interface AdminEnv {
  apiBaseUrl: string;
  cognitoRegion: string;
  cognitoUserPoolId: string;
  cognitoAppClientId: string;
  envLabel: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.trim() === '') {
    throw new Error(`Missing required env var ${name}. See packages/admin/.env.example.`);
  }
  return value;
}

const raw = import.meta.env;

export const env: AdminEnv = {
  apiBaseUrl: required('VITE_API_BASE_URL', raw.VITE_API_BASE_URL).replace(/\/$/, ''),
  cognitoRegion: required('VITE_COGNITO_REGION', raw.VITE_COGNITO_REGION),
  cognitoUserPoolId: required('VITE_COGNITO_USER_POOL_ID', raw.VITE_COGNITO_USER_POOL_ID),
  cognitoAppClientId: required('VITE_COGNITO_APP_CLIENT_ID', raw.VITE_COGNITO_APP_CLIENT_ID),
  envLabel: raw.VITE_ENV_LABEL ?? 'local',
};
